var map = {
	"./alert-icon.svg": 91811,
	"./app-icon.svg": 13842,
	"./bank-icon.svg": 7709,
	"./broken-link-icon.svg": 87937,
	"./check-green-icon.svg": 40251,
	"./credit-card-icon.svg": 49415,
	"./discount-icon.svg": 22360,
	"./heart-icon.svg": 56233,
	"./question-mark-icon.svg": 24003,
	"./success-icon.svg": 24662,
	"./warning-icon.svg": 12517,
	"./whatsapp-icon.svg": 11813
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86343;